import { observable, when } from 'mobx';
import { CXContainerBlock } from '~/components/ClientExperience/OneFlow/models/cx-container-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type { FlowRevision } from '~/models/flow-revision.model';
import { CompanyInfoLayoutType } from '~/types/builder.types';
import { CompositionType } from '~/types/model.types';
import { ICompanyInfoBlockResponse } from '~/types/server.types';
import { setCompanyInfoOnDescendants } from '~/utils/block.utils';

export class CXCompanyInfoBlock
    extends CXContainerBlock
    implements ICompanyInfoBlockResponse
{
    @observable type: 'company_info_block';
    @observable composition_type: CompositionType.CompanyInfo;
    @observable company_info_layout_type: CompanyInfoLayoutType;
    @observable linked_to_company_settings: boolean = true;

    constructor(
        block: ICompanyInfoBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;

        when(
            () => !!this.flow,
            () => setCompanyInfoOnDescendants(this)
        );
    }
}
